/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Expiration_1yearInputs */

const he_notifications_expiration_1year = /** @type {(inputs: Notifications_Expiration_1yearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שנה`)
};

const en_notifications_expiration_1year = /** @type {(inputs: Notifications_Expiration_1yearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Year`)
};

/**
* | output |
* | --- |
* | "1 Year" |
*
* @param {Notifications_Expiration_1yearInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_expiration_1year = /** @type {((inputs?: Notifications_Expiration_1yearInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Expiration_1yearInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_expiration_1year(inputs)
	return en_notifications_expiration_1year(inputs)
});